<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >
        <div>
          <card>
            <v-spacer/>

            <v-dialog
              v-model="dialog"
              persistent
              max-width="768px">
              <card>
                <h4 slot="header">
                  举报类型： {{ editedItem.reply_id ? '回复' : '话题' }}
                  <a
                    :href="webUrl + editedItem.topic_id + '?admin=' + Math.random() +(editedItem.reply_id ? ('#' + editedItem.reply_id) : '')"
                    target="_blank">
                    前往
                  </a>
                </h4>
                <v-container grid-list-md >
                  <v-layout wrap>
                    <v-flex
                      xs12
                      sm12
                      md12>
                      原因： {{ editedItem.reason }}
                    </v-flex>
                    <v-flex
                      xs12
                      sm12
                      md12>
                      话题：{{ editedItem.topic.title }}
                    </v-flex>
                    <v-flex
                      v-if="editedItem.reply_id "
                      xs12
                      sm12
                      md12>
                      回复： {{ (editedItem.reply_id && editedItem.reply) ? editedItem.reply.content : '' }}
                    </v-flex>
                  </v-layout>
                </v-container>

                <v-card-actions>
                  <base-button
                    @click="close">Close</base-button>

                  <v-spacer/>
                </v-card-actions>
              </card>
            </v-dialog>

            <v-data-table
              :headers="headers"
              :items="LinkList"
              :disable-initial-sort="true"
              :rows-per-page-items ="rowsAmount"
              :light="false"
              class="table table-striped"
            >

              <!-- change table header background and text color(or other properties) -->
              <template
                slot="headerCell"
                slot-scope="{ header }"
              >
                <span
                  class="subheading font-weight-light text-general text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template v-slot:items="props">
                <tr @click="editItem(props.item)">

                  <td>{{ props.item.reply_id ? '回复' : '话题' }}</td>
                  <td>{{ props.item.count }}</td>
                  <td>{{ props.item.reason }}</td>
                  <td>
                    {{ props.item.topic.title }}
                  </td>

                  <td>
                    {{ (props.item.reply_id && props.item.reply) ? props.item.reply.content : '' }}
                  </td>

                  <td
                    class="justify-center "
                    @click="deleteItem(props.item)">
                    <i class="tim-icons icon-trash-simple pointer"/>
                  </td>
                </tr>
              </template>
            </v-data-table>
            <v-snackbar
              v-model="snack"
              :timeout="5000"
              :color="snackColor">
              {{ snackText }}
              <v-btn
                flat
                @click="snack = false">Close</v-btn>
            </v-snackbar>
          </card>
        </div>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import BaseButton from '@/components/BaseButton'

export default {
  components: { BaseButton },
  data: () => ({
    snack: false,
    snackColor: '',
    snackText: '',
    pagination: {},
    LinkList: [

    ],
    loading: true,

    webUrl: '',
    startCalendar: false,
    endCalendar: false,

    checkboxAdmin: true,
    checkboxActive: true,
    rowsAmount: [10, 20, 50, { 'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1 }],
    dialog: false,
    headers: [
      {
        text: '类型',
        value: 'reply_id'
      },
      {
        text: '举报次数',
        value: 'count'
      },
      {
        text: '原因',
        value: 'reason'
      },
      {
        text: '话题',
        value: 'topic.title'
      },
      {
        text: '回复',
        value: 'reply_id'
      },
      // {
      //   text: 'Active',
      //   value: 'active',
      // },
      {
        text: 'Action',
        value: 'Action',
        sortable: false
      }
    ],
    editedIndex: -1,
    editedItem: {
      id: '',
      topic_id: '',
      topic: '',
      reply_id: '',
      reply: '',
      reason: ''
      // active: true,
    },
    defaultItem: {
      id: '',
      topic_id: '',
      topic: '',
      reply_id: '',
      reply: '',
      reason: ''
      // active: true,
    }
  }),

  computed: {
    ...mapState('app', ['color']),
    formTitle () {
      return this.editedIndex === -1 ? 'New Link' : 'Edit Link'
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  // called when page is created before dom
  created () {
    this.index()
    this.webUrl = location.protocol + '//' + this.$store.state.city.id + '.' + this.customerWebDomain + '/topics/'
    // this.$store.dispatch('autoRefreshToken')
    // .then(response => console.log(response))
    // .catch(error => console.log(error))
  },

  methods: {
    index () {
      this.$store.state.spinning = true
      let self = this
      axios.get('/spams')
        .then(response => {
          self.LinkList = response.data
          self.$store.state.spinning = false
        })
        .catch(err => {
          if (err.response.status == '403') {
            this.showError('Unauthorized')
          } else {
            this.showError(err.response.data.errors)
          }
          self.$store.state.spinning = false
          console.log(err.response.data.errors)
        })
    },

    // object.assign fills in the empty object with the properties of item
    editItem (item, dbox = true) {
      this.editedIndex = this.LinkList.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = dbox
    },

    callTableAction (item, endpoint, method) {
      let tableItem = this.editedItem
      this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
        .then((response) => this.saveInline())
        .catch(error => {
          console.log(error)
          this.cancelInline
        })
    },

    deleteItem (item) {
      const index = this.LinkList.indexOf(item)
      if (confirm('Are you sure you want to delete this item?')) {
        this.$store.state.spinning = true
        axios.delete('/spams/' + item.id)
          .then((response) => {
            this.LinkList.splice(index, 1)
            this.deleteInline()
            this.close()
            this.$store.state.spinning = false
          }
          )
          .catch(error => {
            if (error.response.status == '403') {
              this.showError('Unauthorized')
            } else {
              this.showError(error.response.data.errors)
            }
            console.log(error)
            this.cancelInline
            this.$store.state.spinning = false
          })
      }
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      // update
      if (this.editedIndex !== -1) {
        this.$store.state.spinning = true
        axios.put('/spams/' + this.editedItem.id, this.editedItem)
          .then((response) => {
            Object.assign(this.LinkList[this.editedIndex], response.data)
            this.saveInline()
            this.close()
            this.$store.state.spinning = false
          }
          )
          .catch(error => {
            if (error.response.status == '422') {
              this.showError(error.response.data.errors)
            }
            console.log(error)
            this.cancelInline
            this.$store.state.spinning = false
          })
      }
      // create
      else {
        this.$store.state.spinning = true
        axios.post('/spams', this.editedItem)
          .then((response) => {
            this.LinkList.unshift(response.data)
            this.saveInline()
            this.close()
            this.$store.state.spinning = false
          })
          .catch(error => {
            if (error.response.status == '422') {
              this.showError(error.response.data.errors)
            }
            console.log(error)
            this.cancelInline
            this.$store.state.spinning = false
          })
      }
    },
    // toasts/snackbar messages for actions
    saveInline () {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Spam saved'
    },
    deleteInline () {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Spam deleted'
    },
    showError (errorMessage) {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = errorMessage || 'Something went wrong, try again later!'
    },
    cancelInline () {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Canceled'
    },
    reset () {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Data reset to default'
    },
    openInline () {
      this.snack = true
      this.snackColor = 'info'
      this.snackText = 'Dialog opened'
    },
    closeInline () {
      console.log('Dialog closed')
    }
  }
}
</script>

<style>
table.v-table thead tr {
  color: red !important;
}
tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, .05);
}
</style>
